<template>
  <div>
    <div class="maitanence text-center">
      <slot name="display_image">
        <img src="@/assets/maintenanceicon.svg" class="mx-auto" />
      </slot>

      <slot name="status_text">
        <h1 class="status--text">
          We’ll be back soon!
        </h1>
        <p>
          This page is down for scheduled maintainence. Please check back in a
          little while.
        </p>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'maintenance-text'
}
</script>

<style scoped lang="scss">
@import '@/global.scss';

header {
  border-bottom: solid 1px;
  height: 80px;
  display: flex;
  align-items: center;
  .logo {
    a {
      height: inherit;
      img {
        height: inherit;
        object-fit: contain;
      }
    }
  }
}

.maitanence {
  height: 100%;
  width: 100%;
  margin-top: 5rem;

  img {
    padding-bottom: 1rem;
    margin: auto;
  }

  h1 {
    padding-bottom: 1rem;
    text-transform: uppercase;
    font-family: 'Editorial New';
    font-size: 2rem;
    font-weight: normal;
    text-align: center;
  }
  p {
    font-weight: 500;
    font-size: 0.813rem;
  }
}
</style>
